import * as css from "./styles/templatePropertyFormStyles.module.scss";

import {Message} from "@zendeskgarden/react-forms";
import {ReactElement} from "react";
import {Dropdown, Field, Item, Label, Menu, Multiselect, Select} from "@zendeskgarden/react-dropdowns";
import Downshift from "downshift";
import {formatterEnumToTitle} from "../../../../../utils/formatters";
import {Tag} from "@zendeskgarden/react-tags";

export interface ITemplatePropertyFormDropdown {
    label: string,
    required: boolean,
    selection: any | any[],
    options: {value: string | number, name: string}[],
    error: string | undefined,
    isMultiselect?: boolean,
    downshiftProps?: Record<string, any>,
    onSelect: (evt: any) => void,
    onBlur: () => void,
}

export default function TemplatePropertyFormDropdown(props: ITemplatePropertyFormDropdown): ReactElement {
    const {
        label,
        required,
        selection,
        options,
        error,
        downshiftProps,
        onSelect,
        onBlur
    } = props;

    function renderOptions() {
        return options.map((option, index) => {
            if (typeof option === 'object' && option !== null) {
                return (
                        <Item key={index} value={option}>
                            {option.name}
                        </Item>
                );
            } else {
                return (
                        <Item key={index} value={option}>
                            {option}
                        </Item>
                );
            }
        });
    }

    function getSelectedItemText() {
        if (typeof selection === 'object' && selection !== null) {
            return selection.name || selection;
        }
        return selection;
    }

    return (
        <Dropdown
            onSelect={onSelect}
            downshiftProps={downshiftProps}
        >
            <Field>
                <Label className={css.templatePropertyFormLabel}>
                    <span>{label}</span>
                    {
                        required && <span className={css.required}>REQUIRED</span>
                    }
                </Label>
                <Select onBlur={onBlur} validation={error ? "error" : undefined}>{getSelectedItemText()}</Select>
                {
                    error &&
                    <Message validation="error">{error}</Message>
                }
            </Field>
            <Menu>
                {renderOptions()}
            </Menu>
        </Dropdown>
    );
}